import { connect } from 'react-redux'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { Logo } from '../newsignin/Logo'
import { Progress } from '../newsignin/Progress'
import { Titles } from '../newsignin/Titles'
import { BackgroundSignUp } from './BackgroundSignUp'
import EmailForm from './EmailForm'
import { Trademark } from './Trademark'
import { FETCH_SESSION } from '../../../_common/redux/auth/actions'
import { PreLoader } from '../../_library/PreLoader'
import { brandsReferralsCheckToken } from '../../../_common/core/http_services/refferers'
import { deleteCookieByName, deleteHostCookieByName, getCookieByName, setHostCookie } from '../../utils/cookies'

const NewSignUpPageContainer = ({ history, FETCH_SESSION, isRnDomain }) => {
  const [loadingUser, setLoadingUser] = useState(true)

  useEffect(() => {
    const ensureWelcomeAbCookie = () => {
      // Ensure the new-frontend AB cookie is applied before the welcome flow proceeds.
      // Reload once so the correct variant can be served based on the cookie.
      const cookieName = 'nf_ab'
      const cookieValue = 'master'
      const reloadGuardKey = 'nf_ab_welcome_reload_done'

      if (getCookieByName(cookieName) === cookieValue) return false
      if (sessionStorage.getItem(reloadGuardKey) === '1') return false

      // Clear both domain and host-only versions, then set host-only for this subdomain.
      // This avoids a subdomain cookie (e.g. set by edge/CDN tooling) overriding a parent-domain cookie.
      deleteCookieByName(cookieName)
      deleteHostCookieByName(cookieName)
      setHostCookie(cookieName, cookieValue, 30)

      // Give the browser a tick to persist the cookie before reloading.
      setTimeout(() => {
        // Re-apply in case something wrote a different value very early in page load.
        setHostCookie(cookieName, cookieValue, 30)
        if (getCookieByName(cookieName) !== cookieValue) return
        sessionStorage.setItem(reloadGuardKey, '1')
        window.location.reload()
      }, 50)

      return true
    }

    const fetchUser = async () => {
      try {
        const session = await FETCH_SESSION({ hideError: true, noAppcues: true })
        if (session) {
          history.push('/')
          return
        } else {
          const willReload = ensureWelcomeAbCookie()
          if (!willReload) setLoadingUser(false)
        }
      } catch (e) {
        const willReload = ensureWelcomeAbCookie()
        if (!willReload) setLoadingUser(false)
      }
    }
    localStorage.removeItem('createAccountState')
    fetchUser()
  }, [history, FETCH_SESSION])
  useEffect(() => {
    window.dataLayerInit()
    window.runGtagScript()
  }, [])
  useEffect(() => {
    const params = new URL(window.location.href).searchParams
    const referral = params.get('r')
    if (referral) {
      brandsReferralsCheckToken(referral)
    }
  }, [])
  return loadingUser ? (
    <PreLoader isRnDomain={isRnDomain} />
  ) : (
    <div className="absolute-container new-sign-up">
      <Logo />
      <Progress width={0} />
      <Titles />
      <BackgroundSignUp>
        <EmailForm />
      </BackgroundSignUp>
      <Trademark />
    </div>
  )
}

const NewSignUpPage = connect(
  state => {
    const { isRnDomain } = state.shared
    return {
      isRnDomain,
    }
  },
  { FETCH_SESSION },
)(NewSignUpPageContainer)

export { NewSignUpPage }
